/* import __COLOCATED_TEMPLATE__ from './kyb-verification-error.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();